<template>
  <div>
    <el-form-item label="播放分组">
      <el-radio v-for="(item, key) in paragraphs" :key="key" v-model="paragraph" :label="item.id">{{item.title}}</el-radio>
    </el-form-item>
    <el-form-item label="学习模式">
      <el-radio v-model="mode" :label="0">整体播放</el-radio>
      <el-radio v-model="mode" :label="1">逐句播放</el-radio>
      <el-radio v-model="mode" :label="2">逐句对话(行业汉语专用)</el-radio>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'kewen',
  props: {
    form: Object
  },
  data () {
    return {
      mode: 0,
      paragraph: 0,
      paragraphs: [
        {id: 0, title: '全部'}
      ]
    }
  },
  watch: {
    form (newVal, oldVal) {
      if (newVal.entity_type !== oldVal.entity_type || newVal.entity_id !== oldVal.entity_id) {
        this.initData()
      }
    }
  },
  mounted () {
    this.initData()
    this.fetchData()
  },
  methods: {
    initData () {
      if (!this.form) {
        return
      }
      if (this.form.entity_type === 'kwparg') {
        this.paragraph = this.form.entity_id
      } else {
        this.paragraph = 0
      }
      var utils = require('@/js/utils.js').default
      this.mode = utils.getAttr(this.form, 'entity_data.kewen_mode') || 0
    },
    fetchData () {
      if (!this.form) {
        return
      }
      this.$http.get(this.$urls.kewen_paragraphs, {
        params: {
          entity_type: this.form.entity_type,
          entity_id: this.form.entity_id
        }
      }).then(res => {
        this.paragraphs = [{id: 0, title: '全部'}].concat(res.data)
      })
    },
    getFormData () {
      if (this.mode === 2) {
        return {
          entity_type: 'industry_kewen',
          entity_id: this.form.entity_id,
        }
      } else if (this.paragraph > 0) {
        return {
          entity_type: 'kwparg',
          entity_id: this.paragraph,
          data: {
            kewen_mode: this.mode
          }
        }
      } else {
        let p = this.paragraphs.find(n => n.id === this.paragraph)
        return {
          entity_type: 'kewen',
          entity_id: p.kid,
          data: {
            kewen_mode: this.mode
          }
        }
      }
    }
  }
}
</script>
